import { Spinner } from "@shapr3d/frontend-lib";
import classNames from "classnames";
import type React from "react";

import { usePriceConfig } from "../../../hooks/usePriceConfig";
import { SubscriptionPeriod, SubscriptionTier } from "../../../types";
import { BulletPoint } from "./BulletPoint";

import style from "./InvitePromo.module.css";

interface InvitePromoProps {
  type: "contributor" | "editor";
  period?: SubscriptionPeriod;
}

export const InvitePromo: React.FC<InvitePromoProps> = ({ type, period }) => {
  const { data: priceConfigData, isLoading: isPriceConfigLoading } = usePriceConfig();
  const tierConfig = priceConfigData?.tiers[SubscriptionTier.Lite];

  return (
    <div className={style.contributorPromoContainer}>
      {type === "editor" && (
        <>
          {isPriceConfigLoading && (
            <div className={style.title}>
              &nbsp;
              <Spinner size={18} />
            </div>
          )}
          {!isPriceConfigLoading && (
            <span
              className={style.title}
            >{`${priceConfigData?.currencySymbol}${period === SubscriptionPeriod.Monthly ? tierConfig?.monthly : tierConfig?.yearly}/seat`}</span>
          )}
          <span className={classNames(style.subtitle, style.blue)}>
            <mark>Editors</mark> enjoy unlimited access to all Shapr3D features.
          </span>
          <div className={style.benefits}>
            <BulletPoint icon="checkmark_circle_filled" text="Edit projects" />
            <BulletPoint icon="checkmark_circle_filled" text="Create new projects" />
            <BulletPoint icon="checkmark_circle_filled" text="Export projects" />
            <BulletPoint icon="checkmark_circle_filled" text="Draft projects" />
          </div>
        </>
      )}
      {type === "contributor" && (
        <>
          <span className={style.title}>Free</span>
          <span className={classNames(style.subtitle, style.yellow)}>
            <mark>Contributors</mark> can view and edit existing team projects with all modeling
            tools. Can only be claimed with company email invites.
          </span>
          <div className={style.benefits}>
            <BulletPoint icon="checkmark_circle_filled" text="Edit projects" />
            <BulletPoint icon="checkmark_circle" text="Up to 2 projects" />
            <BulletPoint icon="close_circle_filled" text="Export projects" />
            <BulletPoint icon="close_circle_filled" text="Draft projects" />
          </div>
        </>
      )}
    </div>
  );
};
